
import _ from 'lodash';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
import { hasPermission } from '../template/auth.js';
import EditGameDifficultySliderPopover from './edit-game-difficulty-slider-popover.vue';

export default {
  components: {
    VueSlider: VueSlider,
    EditGameDifficultySliderPopover: EditGameDifficultySliderPopover
  },

  props: {
    defaultConfig: {
      type: [Number, Array],
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    marks: {
      type: Boolean,
      default: false
    },
    unit: {
      type: [String, Number]
    },
    interval: {
      type: Number
    },
    data: {
      type: Array
    },
    editable: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      formValue: {
        min: this.min,
        max: this.max
      },

      errorText: ''
    };
  },


  computed: {
    innerEditable: function innerEditable() {
      return hasPermission({
        key: 'game-config.slider-range-editable',
        permissionKeys: this.$store.state.creative.template.permissions
      }) && this.editable;
    },


    innerConfig: {
      get: function get() {
        return this.defaultConfig;
      },
      set: function set(value) {
        this.$emit('change', {
          conf: {
            value: value
          }
        });
      }
    },

    // 自定义数据，自定义数据时不允许调节 min/max
    isCustomData: function isCustomData() {
      return Array.isArray(this.data);
    },
    sliderProps: function sliderProps() {
      return {
        min: this.min,
        max: this.max,
        // 默认100等分
        interval: this.interval || Number(((this.max - this.min) / 100).toFixed(2)),
        // tooltip: 'hover',
        lazy: true,
        marks: this.marks,
        data: this.isCustomData ? this.data : null
      };
    },


    // 判断是否是区间范围值选取
    isMultipleValue: function isMultipleValue() {
      return _.isArray(this.defaultConfig);
    },
    sliderValue: function sliderValue() {
      if (this.isMultipleValue) {
        return this.defaultConfig.join('-');
      }
      return this.defaultConfig;
    }
  },

  watch: {
    max: function max() {
      this.checkDiff();
    },
    min: function min() {
      this.checkDiff();
    }
  },

  mounted: function mounted() {
    this.checkDiff();
  },


  methods: {
    checkDiff: function checkDiff() {
      if (this.min > this.max) {
        this.errorText = this.$t('playTurbo.custom.difficultySlider.form.min.warningText4');
      } else {
        this.errorText = '';
      }
    },
    handleChange: function handleChange(_ref) {
      var min = _ref.min,
          max = _ref.max;

      var value = min;
      if (this.isMultipleValue) {
        value = [min, max];
      }
      this.$emit('change', {
        conf: {
          min: min,
          max: max,
          value: value
        }
      });
    }
  }
};